export default {
    listeners: {
        mouseenter: true,
        mouseleave: true,
    }
}